import {useMemo} from 'react';
import './Stepper.scss';

interface IStepperProps {
  step: number;
  stepsNumber: number;
}

const Stepper = ({step, stepsNumber}: IStepperProps) => {
  const progressWidth = useMemo(() => {
    const width = ((step - 1) / (stepsNumber - 1)) * 100;

    return width;
  }, [step, stepsNumber]);

  return (
    <div className="stepper">
      <div className="stepper__progress" style={{width: `${progressWidth}%`}} />
      <div className="stepper__line" />
      <div className="stepper__wrapper">
        <div className={`stepper__step ${step === 1 && 'stepper__step--current'} ${step > 1 && 'stepper__step--done'}`}>
          1
        </div>
      </div>
      <div className="stepper__wrapper">
        <div className={`stepper__step ${step === 2 && 'stepper__step--current'} ${step > 2 && 'stepper__step--done'}`}>
          2
        </div>
      </div>
      <div className="stepper__wrapper">
        <div className={`stepper__step ${step === 3 && 'stepper__step--current'}`}>3</div>
      </div>
    </div>
  );
};

export default Stepper;
